import { defineElement } from '@umbraco-ui/uui-base/lib/registration';
import { css, LitElement, html } from 'lit';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let UUIButtonGroupElement = class extends LitElement {
  render() {
    return html`<slot></slot>`;
  }
};
UUIButtonGroupElement.styles = [
  css`
      :host {
        display: inline-flex;
        align-items: stretch;
      }

      ::slotted(*) {
        --uui-button-border-radius: 0;
        flex-grow: 1;
      }

      ::slotted([look='outline']:not(:first-child)) {
        --uui-button-merge-border-left: 1;
      }
      ::slotted([look='placeholder']:not(:first-child)) {
        --uui-button-merge-border-left: 1;
      }

      ::slotted(*:first-child) {
        --uui-button-border-radius: var(--uui-border-radius,3px) 0 0
          var(--uui-border-radius,3px);
      }
      ::slotted(*:last-child) {
        --uui-button-border-radius: 0 var(--uui-border-radius,3px)
          var(--uui-border-radius,3px) 0;
      }

      ::slotted(uui-popover) {
        width: unset;
        --uui-popover-toggle-slot-button-border-radius: 0;
      }
      ::slotted(uui-popover:not(:first-child)) {
        --uui-popover-toggle-slot-button-merge-border-left: 1;
      }
      ::slotted(uui-popover:first-child) {
        --uui-popover-toggle-slot-button-border-radius: var(--uui-border-radius,3px)
          0 0 var(--uui-border-radius,3px);
      }
      ::slotted(uui-popover:last-child) {
        --uui-popover-toggle-slot-button-border-radius: 0
          var(--uui-border-radius,3px) var(--uui-border-radius,3px) 0;
      }

      ::slotted(*:hover) {
        z-index: 1;
      }
    `
];
UUIButtonGroupElement = __decorateClass([
  defineElement("uui-button-group")
], UUIButtonGroupElement);

export { UUIButtonGroupElement };
